import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { captchaMixin } from '../utils/captchaMixin';
export default {
  name: 'Captcha',
  mixins: [captchaMixin],
  data: function data() {
    var phoneNum = this.phone.split('').reduce(function (total, current, index) {
      if (index > 2 && index < 7) {
        total += '*';
      } else {
        total += current;
      }

      return total;
    }, '');
    return {
      area: '.captcha',
      // minxin 需要的 area
      phoneNum: phoneNum
    };
  },
  created: function created() {
    // 出现弹框 说明滑块验证通过
    this.countDown();
  },
  mounted: function mounted() {
    this.$refs.captchaRef.focus();
  },
  methods: {
    // 确认按钮，校验验证码是否正确&改密码
    onOk: function onOk() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$submit, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.submit();

              case 2:
                _yield$_this$submit = _context.sent;
                status = _yield$_this$submit.status;
                data = _yield$_this$submit.data;

                if (status === 1) {
                  _this.$attrs.close({
                    data: data
                  });
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};